import React from 'react';
import style from "./index.module.css";
import {Breadcrumb, Divider} from "antd";
import CertificateNavModule from "../../components/certificateNavModule";

const HireInformation = () => {
    const baseItem = [
        {
            title: <div>首页</div>,
        },
        {
            title: "招聘信息",
        },
    ];

    return (
        <div className={style.pageContainer}>
            <Breadcrumb
                items={baseItem}
            />

            <div className={style.content}>
                <div className={style.leftNavBar}>
                    <CertificateNavModule/>
                </div>

                <div className={style.rightMainContainer}>
                    <div>
                        <div className={style.pageTitle}>招聘信息</div>
                        <Divider style={{padding: '0 30px', borderColor: '#043554'}}>HIRE INFORMATION</Divider>
                    </div>

                    <div style={{color:'#666666'}}>
                        {/*<div>*/}
                        {/*    招聘岗位*/}
                        {/*</div>*/}
                        <div className={style.articleBlock}>
                            <div className={style.articleBlockTitle}>招聘岗位</div>
                            <div>认证技术管理人员/产品认证兼职审核员</div>
                        </div>

                        <div style={{marginTop:40}} className={style.articleBlock}>
                            <div className={style.articleBlockTitle}>职位描述</div>
                            <div>1、按公司要求完成指派的认证审核工作；</div>
                            <div>2、按公司要求参与并完成技术文件的编制或修订工作；</div>
                            <div>3、协助做好客户维护和市场拓展工作；</div>
                            <div>4、配合公司各部门完成公司内部培训和交流；</div>
                            <div>5、完成上级领导交办的其他临时工作</div>
                        </div>

                        <div style={{marginTop:40}}  className={style.articleBlock}>
                            <div className={style.articleBlockTitle}>任职资格</div>
                            <div>具备产品审核员注册资质，能源管理体系或温室气体核查员注册资格，三年以上产品审核经历，一年以上双碳相关咨询认证经历，且具备审核组长的资质和能力，可独立开展审核工作，并具有见证实习审核资格，如有全职审核经历的可放宽审核年限，有电池产品审核经历优先考虑</div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

    );
};

export default HireInformation;